<template>
    <div style="height: 100%;">
        <!--磁悬浮内机-->
        <div style="padding-top: 15px;font-weight: bold;margin-left: 25px;">
            <span
                style="width: 5px;height: 15px;border-left: 2px solid #299FFB;display: inline-block;margin-bottom: -2px;margin-right: 5px;"></span>
            <span>磁悬浮内机</span>
        </div>
        <div class="scroll-container" style="height: 80%;overflow: hidden;" v-if="data.length > 0">
            <vue-seamless-scroll 
                :data="data"
                :class-option="classOption"
                @scrollEnd="onScrollEnd">
                <el-row :key="item.id" style="padding-top: 10px;margin-top: 20px;font-size: .9rem;" v-for="item in data">
                    <el-col :span="8" style="text-align: center;padding: 5px 10px 0 9%;">
                        <img src="../../../assets/images/comprehensive/空调.png">
                        <div style="font-weight: bold;margin-top: 5px;">{{ item.name }}</div>
                    </el-col>
                    <el-col :span="11">
                        <span :key="history.id" v-for="history in item.deviceMeasuringPointHistoryList">
                            <div style="width: 130%;border-bottom: 1px solid rgba(41, 159, 251, .2);padding-bottom: 3px;"
                                v-if="/回风平均温度/.test(history.pointName)">
                                <img src="../../../assets/images/comprehensive/当前温度.png"
                                    style="margin-right: 20px;margin-top: -4px;">
                                <span>回风平均温度：<span id="currentTemp"
                                        style="font-size: 1rem;color: rgba(41, 159, 251, 1);font-weight: bold">{{
                                            history.pointValueName
                                        }}</span></span>
                            </div>
                            <div style="width: 130%;border-bottom: 1px solid rgba(41, 159, 251, .2);padding-bottom: 3px;"
                                v-if="/送风平均温度/.test(history.pointName)">
                                <img src="../../../assets/images/comprehensive/当前温度.png"
                                    style="margin-right: 20px;margin-top: -4px;">
                                <span>送风平均温度：<span id="currentTemp"
                                        style="font-size: 1rem;color: rgba(41, 159, 251, 1);font-weight: bold">{{
                                            history.pointValueName
                                        }}</span></span>
                            </div>
                        </span>
                    </el-col>
                </el-row>
            </vue-seamless-scroll>
        </div>
        <no-data style="margin-top: 15%;" v-else></no-data>
    </div>
</template>

<script>
import { getMagneticSuspendMachineData } from "@/network/measuring-point-history";
import NoData from "@/components/NoData";
import vueSeamlessScroll from 'vue-seamless-scroll'

export default {
    name: "VentilationWall",
    components: { NoData, vueSeamlessScroll },
    inject: ['overflow'],
    props: {
        spaceId: {
            type: String,
            default: () => null
        }
    },
    data() {
        return {
            data: [],
            typeList: ["PM_CXFNJ"],
            pointCodes: [],
            pageNum: 1,
            pageSize: 5,         // 减少每页数据量，使滚动更流畅
            totalPages: 0,
            isLoading: false,
            timer: null,
            classOption: {
                step: 0.8,           // 稍微加快滚动速度
                limitMoveNum: 2,     // 开始无缝滚动的数据量
                hoverStop: true,     // 鼠标悬停暂停
                direction: 1,        // 向上滚动
                autoPlay: true,      // 自动播放
                switchSingleStep: 1, // 单步切换步长
                switchDelay: 4000,   // 停顿时间
                switchDisabled: false,
                singleHeight: 130,   // 设置单个数据高度
                waitTime: 1000       // 单步停止等待时间
            }
        }
    },

    mounted() {
        this.overflow();
        this.init();
    },

    methods: {
        async init() {
            try {
                console.log('初始化开始 ==========>');
                const res = await getMagneticSuspendMachineData({
                    spaceId: this.spaceId,
                    typeList: this.typeList,
                    pointCodes: this.pointCodes,
                    pageNum: 1,
                    pageSize: this.pageSize
                });
                
                if (res.code === 0) {
                    this.totalPages = Math.ceil(res.total / this.pageSize);
                    console.log('设置总页数:', this.totalPages);
                    this.startLoading();
                }
            } catch (error) {
                console.error('初始化失败:', error);
            }
        },

        startLoading() {
            this.destroy(); // 清除已存在的定时器
            // 每5秒更新一次数据
            this.timer = setInterval(() => {
                this.getData();
            }, 5000);
            // 首次加载数据
            this.getData();
        },

        async getData() {
            if (this.isLoading) {
                return;
            }

            try {
                this.isLoading = true;

                const res = await getMagneticSuspendMachineData({
                    spaceId: this.spaceId,
                    typeList: this.typeList,
                    pointCodes: this.pointCodes,
                    pageNum: this.pageNum,
                    pageSize: this.pageSize
                });

                if (res.code === 0 && res.data?.records?.length > 0) {
                    // 更新数据
                    this.data = res.data.records;

                    // 更新总页数（如果后端返回了新的总页数）
                    if (res.data.pages !== this.totalPages) {
                        this.totalPages = res.data.pages;
                    }

                    // 循环翻页
                    const nextPage = (this.pageNum % this.totalPages) + 1;
                    this.pageNum = nextPage;
                }
            } catch (error) {
                console.error('加载数据失败:', error);
            } finally {
                this.isLoading = false;
                console.log('数据加载完成 ==========>\n');
            }
        },

        destroy() {
            if (this.timer) {
                console.log('清理定时器');
                clearInterval(this.timer);
                this.timer = null;
            }
        },

        onScrollEnd() {
            console.log('滚动结束事件触发');
        }
    },

    watch: {
        spaceId(newVal) {
            console.log('spaceId变化:', newVal);
            this.pageNum = 1;
            this.data = [];
            this.init();
        }
    },

    beforeDestroy() {
        console.log('组件销毁');
        this.destroy();
    }
}
</script>
<style scoped></style>